module.exports = __webpack_public_path__ + "img/item-5.80b689a.png";